// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alertBox {
  border-bottom: 1px solid #808080;
  font-size: smaller;
  z-index: 1000;
}

.container {
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  gap: 3rem;
  display: inline-flex;
}

.title {
  font-size: large;
  font-weight: bold;
}

.messageContent {
  padding-top: 5px;
  flex-grow: 1;
  margin-left: 16rem;
  margin-right: auto;
}

.button {
  height: 2.5rem;
  border-radius: 0.25rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  color: white;
  width: 80px;
  align-self: flex-end;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
}

.button:hover {
  background: var(--hover-color) !important;
}

.button:active {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/messageAlert.scss"],"names":[],"mappings":"AACA;EACI,gCAAA;EACA,kBAAA;EACA,aAAA;AAAJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AACJ;;AACE;EACE,gBAAA;EACA,iBAAA;AAEJ;;AAAE;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAGJ;;AADE;EACE,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,6EAAA;AAIJ;;AAHG;EACC,yCAAA;AAMJ;;AAJE;EACE,YAAA;AAOJ","sourcesContent":["\n.alertBox {\n    border-bottom: 1px solid #808080;\n    font-size: smaller;\n    z-index: 1000;\n}\n.container {\n    max-width: 100%; \n    margin-left: auto;\n    margin-right: auto;\n    align-items: center;\n    gap: 3rem;\n    display: inline-flex;\n  }\n  .title {\n    font-size: large;\n    font-weight: bold;\n  }\n  .messageContent {\n    padding-top: 5px;\n    flex-grow: 1;\n    margin-left: 16rem;\n    margin-right: auto;\n  }\n  .button {\n    height: 2.5rem; \n    border-radius: 0.25rem; \n    padding-left: 0.75rem; \n    padding-right: 0.75rem;\n    color: white; \n    width: 80px;\n    align-self: flex-end;\n    margin-bottom: 10px;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1); \n  }.button:hover{\n    background: var(--hover-color) !important;\n  }\n  .button:active{\n    opacity: 0.8;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
